import useSWR from 'swr';

import { GetCurrentUser } from 'common/graphql/queryDescriptors';
import { GET_CURRENT_USER } from 'common/graphql/queries';
import { print } from 'graphql/language/printer';
import { RequestDocument } from 'graphql-request/dist/types';
import { swrFetcher } from 'common/services/swr';
import { useDispatch } from 'react-redux';

export const useCurrentUser = () => {
  const dispatch = useDispatch();

  useSWR(print(GET_CURRENT_USER), (query: RequestDocument) => swrFetcher(query, () => {
    //@ts-ignore
    GetCurrentUser({}).onError(undefined, dispatch);
  }));
}